<template>
  <div class="qr-fixed" @click="close">
    <img :src="QRcode" />
  </div>
</template>

<script>
// 二维码
import QRCode from "qrcode";
export default {
  props: {
    link: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      QRcode: ""
    };
  },
  mounted() {
    console.log(this.link);
    if (this.link) {
      this.QRcode = this.getQRCode(this.link);
    }
  },
  methods: {
    //生成二维码
    getQRCode(data) {
      let img;
      QRCode.toDataURL(data, { errorCorrectionLevel: "M" }, (err, url) => {
        if (!err) {
          img = url;
        } else {
          console.log("生成二维码失败");
        }
      });
      return img;
    },
    close() {
        this.$emit("close")
    }
  }
};
</script>

<style  lang="less" scoped>
// 二维码模态框
.qr-fixed {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 300px;
    height: 300px;
  }
}
</style>